import { SET_HEADER, SET_MENU } from 'actions/types'
import cloneDeep from 'clone-deep'

import { createReducer } from '../utils'

// Persist the Servicing-mode header override so it survives a browser refresh
// (otherwise the top header reverts to Origination on reload).
const OVERRIDE_KEY = 'servicingHeaderOverride'
const loadOverride = () => {
  try {
    return JSON.parse(localStorage.getItem(OVERRIDE_KEY) || 'null') || {}
  } catch {
    return {}
  }
}
const saveOverride = (reportsOverride: any, servicingMenu: any) => {
  try {
    localStorage.setItem(OVERRIDE_KEY, JSON.stringify({ reportsOverride, servicingMenu }))
  } catch {
    // ignore storage errors
  }
}

const getInitialState = () => {
  const saved = loadOverride()
  return {
    activeChangeFlag: true,
    menu: {},
    reportsOverride: saved.reportsOverride ?? null,
    // Extra top-header items shown only while in a given mode (e.g. Servicing):
    // array of { key, name, href } injected client-side by the Pipeline page.
    servicingMenu: saved.servicingMenu ?? null,
  }
}

export const header = createReducer(getInitialState(), {
  [SET_HEADER]: (state: any, payload: any) => {
    let newState = cloneDeep(state)
    const data = payload?.data || {}
    if (data.activeChangeFlag) newState.activeChangeFlag = !newState.activeChangeFlag
    if ('reportsOverride' in data) {
      newState.reportsOverride = data.reportsOverride
    }
    if ('servicingMenu' in data) {
      newState.servicingMenu = data.servicingMenu
    }
    if ('reportsOverride' in data || 'servicingMenu' in data) {
      saveOverride(newState.reportsOverride, newState.servicingMenu)
    }
    return newState
  },
  [SET_MENU]: (state: any, payload: any) => {
    let newState = cloneDeep(state)
    newState.menu = payload.data
    return newState
  },
})
